<template>
    <div v-if="$verify.has_perm('view_integracaoclassroom')">
        <v-row class="py-3 px-1">
            <v-btn color="secondary" elevation="0"
                @click.prevent="loadMore(StateLogsMoodle.next)"
                :disabled="StateLogsMoodle && !StateLogsMoodle.next">
                <v-icon small>mdi-arrow-left</v-icon> &nbsp; Mais antiga
            </v-btn>
            <v-btn color="secondary" elevation="0"
                @click.prevent="loadMore(StateLogsMoodle.previous)"
                :disabled="StateLogsMoodle && !StateLogsMoodle.previous">
                Mais recente &nbsp; <v-icon small>mdi-arrow-right</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="secondary" elevation="0"
                @click.prevent="get_logs"
                :disabled="StateLogsMoodleLoading"
                :loading="StateLogsMoodleLoading">
                <v-icon small>mdi-sync</v-icon>  Recarregar Logs
            </v-btn>
        </v-row>
        <v-row>
            <v-col cols="12" sm="4" md="3">
                <v-select :items="[1, 5, 10, 25]" v-model="page_size"
                    label="Resultados por página"
                    >
                </v-select>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="4" md="3" align="right">
                {{(StateLogsMoodle||{}).count || 0}} Registros
            </v-col>
        </v-row>
        <v-card v-for="log, i in (StateLogsMoodle||{}).results || []" :key="i" class="my-1"
            variant="outlined">
            <v-card-title>
                <div>Rotina executada em: {{$verify.formatarData(log.atualizado_em)}}</div>
            </v-card-title>
            <v-card-text>
                <div>
                    <v-icon :color="log.has_error ? 'error': 'success'">
                        {{log.has_error ? 'mdi-message-alert': 'mdi-marker-check'}}
                    </v-icon> Executado com {{log.has_error ? 'erros' : 'sucesso'  }}
                </div>
                <div>
                    <code v-html="log.get_log" class="px-8"></code>
                </div>
            </v-card-text>
        </v-card>
        <v-row class="py-3 px-1">
            <v-btn color="secondary" elevation="0"
                @click.prevent="loadMore(StateLogsMoodle.next)"
                :disabled="StateLogsMoodle && !StateLogsMoodle.next">
                <v-icon small>mdi-arrow-left</v-icon> &nbsp; Mais antiga
            </v-btn>
            <v-btn color="secondary" elevation="0"
                @click.prevent="loadMore(StateLogsMoodle.previous)"
                :disabled="StateLogsMoodle && !StateLogsMoodle.previous">
                Mais recente &nbsp; <v-icon small>mdi-arrow-right</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
        </v-row>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ConfigService from '../../services/index'
const configService = new ConfigService()
export default {
    data:()=>({
        page_size:1
    }),
    mounted(){
        this.get_logs()
    },
    methods:{
        ...mapActions(['GetLogsMoodleUNDB']),
        ...mapMutations(['SetLogsMoodle']),
        async loadMore(url){
            let response = await configService.genericGetRequest(url, {search: this.$route.query?.instancia})
            this.SetLogsMoodle(response.data)
        },
        get_logs(){
            const page_size = this.page_size
            this.GetLogsMoodleUNDB({page_size, search: this.$route.query?.instancia})
        }
    },
    computed:{
        ...mapGetters(['StateLogsMoodle','StateLogsMoodleLoading',])
    },
    watch:{
        page_size(){
            this.get_logs()
        }
    }
}
</script>